export default {
      id: "icon-P_LTV-usage",
      viewBox: "0 0 32 32",
      url: "/" + "assets/sprite.svg#icon-P_LTV",
      toString: function () {
        return this.url;
      }
    }